import { render, staticRenderFns } from "./Unit-catalog.vue?vue&type=template&id=4959bab2"
import script from "./Unit-catalog.vue?vue&type=script&lang=js"
export * from "./Unit-catalog.vue?vue&type=script&lang=js"
import style0 from "./Unit-catalog.vue?vue&type=style&index=0&id=4959bab2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports